import * as React from 'react';

import { SVGProps } from '../../types';

export const IconVideoSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect
      x="2.75"
      y="4.75"
      width="18.5"
      height="14.5"
      rx="5.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M8 9.4277C8 8.73374 8.68956 8.25075 9.34174 8.48791L16.4156 11.0602C17.2932 11.3794 17.2932 12.6206 16.4156 12.9398L9.34174 15.5121C8.68956 15.7493 8 15.2663 8 14.5723V9.4277Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
